import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Inventory_ds_inventory_material_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { fullTextSearch?: string, ownerId?: number, projectId?: number, warehouseId?: number, materialIds?: number[], skip?: number, take?: number }): 
  Promise<{ result: { WarehouseId?: number, MaterialId?: number, PackagedId?: number, GrossWeight?: number, PackagedAmount?: number, Material?: { Description?: string, LookupCode?: string, Name?: string, ProjectId?: number, Project?: { LookupCode?: string }, Status?: { Name?: string } }, Packaging?: { ShortName?: string }, Warehouse?: { Name?: string }, WeightUom?: { Short_name?: string } }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { fullTextSearch?: string, ownerId?: number, projectId?: number, warehouseId?: number, materialIds?: number[], skip?: number, take?: number, $top?: number, $skip?: number, $orderby?: { column: ('WarehouseId' | 'MaterialId' | 'PackagedId' | 'GrossWeight' | 'PackagedAmount' | 'Material.Description' | 'Material.LookupCode' | 'Material.Name' | 'Material.ProjectId' | 'Material.Project.LookupCode' | 'Material.Status.Name' | 'Packaging.ShortName' | 'Warehouse.Name' | 'WeightUom.Short_name'), order: ('asc' | 'desc') }[], $filter?: { operator: ('and' | 'or'), operands: { numberFilters?: { column: ('WarehouseId' | 'MaterialId' | 'PackagedId' | 'GrossWeight' | 'PackagedAmount' | 'Material.ProjectId'), operation: ('equals' | 'notEqual' | 'empty' | 'lessThan' | 'lessThanOrEqual' | 'greaterThan' | 'greaterThanOrEqual'), value: number }[], numberMultiFilters?: { column: ('WarehouseId' | 'MaterialId' | 'PackagedId' | 'GrossWeight' | 'PackagedAmount' | 'Material.ProjectId'), operation: ('in' | 'notIn'), value: number[] }[], stringFilters?: { column: ('Material.Description' | 'Material.LookupCode' | 'Material.Name' | 'Material.Project.LookupCode' | 'Material.Status.Name' | 'Packaging.ShortName' | 'Warehouse.Name' | 'WeightUom.Short_name'), operation: ('equals' | 'notEqual' | 'empty' | 'contains' | 'notContains' | 'startsWith' | 'endsWith' | 'blank' | 'notBlank'), value: string }[], stringMultiFilters?: { column: ('Material.Description' | 'Material.LookupCode' | 'Material.Name' | 'Material.Project.LookupCode' | 'Material.Status.Name' | 'Packaging.ShortName' | 'Warehouse.Name' | 'WeightUom.Short_name'), operation: ('in' | 'notIn'), value: string[] }[], operator: ('and' | 'or') }[] } }): 
  Promise<{ result: { WarehouseId?: number, MaterialId?: number, PackagedId?: number, GrossWeight?: number, PackagedAmount?: number, Material?: { Description?: string, LookupCode?: string, Name?: string, ProjectId?: number, Project?: { LookupCode?: string }, Status?: { Name?: string } }, Packaging?: { ShortName?: string }, Warehouse?: { Name?: string }, WeightUom?: { Short_name?: string } }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { fullTextSearch?: string, ownerId?: number, projectId?: number, warehouseId?: number, materialIds?: number[], skip?: number, take?: number, $keys: { WarehouseId?: number, MaterialId?: number, PackagedId?: number }[] }): 
  Promise<{ result: { WarehouseId?: number, MaterialId?: number, PackagedId?: number, GrossWeight?: number, PackagedAmount?: number, Material?: { Description?: string, LookupCode?: string, Name?: string, ProjectId?: number, Project?: { LookupCode?: string }, Status?: { Name?: string } }, Packaging?: { ShortName?: string }, Warehouse?: { Name?: string }, WeightUom?: { Short_name?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      fullTextSearch?: string, ownerId?: number, projectId?: number, warehouseId?: number, materialIds?: number[], skip?: number, take?: number    }) {
      return false;
    }
}
